// extracted by mini-css-extract-plugin
module.exports = {"errorImage":"Ageing_errorImage__2ZJiU","description":"Ageing_description__1SrpP"};